import React from "react"

import moduleStyles from "./svgIcon.module.css"

export const SvgIcon = ({ icon, className }) => {
  return (
    <div
      dangerouslySetInnerHTML={{ __html: icon }}
      className={`${moduleStyles.container} fill-current ${
        className && className
      }`}
    />
  )
}
